// Details.jsx
import React from 'react';
import Notes from "./Notes/Notes.jsx";
import AppointmentTabs from './AppointmentTabs/AppointmentTabs.jsx';
import Classes from './Details.module.css';

const Details = ({ loading, user, bookings, invoices }) => {
  return (
    <div className={Classes.details}>
      <div className={Classes.detailsLeft}>
        <Notes
          loading={loading}
          userId={user?._id}
          notes={(user?.notes || [])}
        />
      </div>
      <div className={Classes.detailsRight}>
        <AppointmentTabs
          loading={loading}
          user={user}
          bookings={bookings}
          invoices={invoices}
        />
      </div>
    </div>
  );
};

export default Details;
